import type { ChapterGateReview } from './types'

export type ParsedGate = {
  review: ChapterGateReview
  summaryIfPass: string
}

/** 从模型输出里抠 JSON 门控结果 */
export function parseGateReviewJson(raw: string): ParsedGate | null {
  const text = String(raw || '').trim()
  if (!text) return null
  let jsonStr = text
  const fenced = text.match(/```(?:json)?\s*([\s\S]*?)```/)
  if (fenced) jsonStr = fenced[1].trim()
  else {
    const start = text.indexOf('{')
    const end = text.lastIndexOf('}')
    if (start >= 0 && end > start) jsonStr = text.slice(start, end + 1)
  }
  try {
    const o = JSON.parse(jsonStr) as Record<string, unknown>
    const passed = Boolean(o.passed)
    const alignScore = Math.max(0, Math.min(100, Number(o.alignScore) || 0))
    const findings = Array.isArray(o.findings)
      ? o.findings.map((x) => String(x)).filter(Boolean)
      : []
    const revisions = Array.isArray(o.revisions)
      ? o.revisions.map((x) => String(x)).filter(Boolean)
      : []
    const summaryIfPass = String(o.summaryIfPass ?? '').trim()
    return {
      review: {
        at: new Date().toISOString(),
        passed,
        alignScore,
        findings,
        revisions,
      },
      summaryIfPass: passed ? summaryIfPass : '',
    }
  } catch {
    return null
  }
}
